import { CampaignProcess, CampaignType } from 'utils/constants/campaign';

import { selectCampaignProcess } from 'store/models/createCampaign';
import { useSelector } from 'store/utils';

interface CampaignProcessState {
    isCreateCampaign: boolean;
    isEditCampaign: boolean;
    isEditAdvertising: boolean;
}

export const useCampaignProcess = (): CampaignProcessState => {
    const campaignProcess = useSelector(selectCampaignProcess);
    const campaignType = useSelector((state) => state.createCampaign.campaignType);

    return {
        isCreateCampaign: campaignProcess === CampaignProcess.Create,
        isEditCampaign: campaignProcess === CampaignProcess.Edit,
        isEditAdvertising: campaignProcess === CampaignProcess.Edit && campaignType === CampaignType.Advertising,
    };
};
